import { render, staticRenderFns } from "./MechanismBasisCreate.vue?vue&type=template&id=7faa1dd0&scoped=true"
import script from "./MechanismBasisCreate.vue?vue&type=script&lang=js"
export * from "./MechanismBasisCreate.vue?vue&type=script&lang=js"
import style0 from "./MechanismBasisCreate.vue?vue&type=style&index=0&id=7faa1dd0&prod&scoped=true&lang=css"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7faa1dd0",
  null
  
)

export default component.exports